import type { FC } from 'react';

import type { Account } from '@shared/products-types';
import { PersonalizationCard as SharedPersonalizationCard } from '@shared/products-components';
import type { ProductWithHelpers } from '@shared/products-core';
import { useActiveProduct } from '@shared/products-core';

import { ColorChange } from './customizations/ColorChange';
import { AliasChange } from './customizations/AliasChange';
import { DashboardAppearanceChange } from './customizations/DashboardAppearanceChange';
import { PersonalizationAvatar } from './components/PersonalizationAvatar';

type Props = {
    'data-cy': string;
};

export const PersonalizationCard: FC<Props> = ({ 'data-cy': dataCy }) => {
    const { productI18N, alias = '' } = useActiveProduct<ProductWithHelpers<Account>>();

    return (
        <SharedPersonalizationCard
            actions={[
                <AliasChange key="alias-change" trigger="productDetail" />,
                <ColorChange key="color-change" />,
                <DashboardAppearanceChange key="dashboard-change" />,
            ]}
            avatar={<PersonalizationAvatar />}
            subtitle={productI18N}
            alias={alias || productI18N}
            data-cy={dataCy}
        />
    );
};
